/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/reviews';

type ToggleButtonForTogglableContentProps = {
  collapsed: boolean;
};

const styles = {
  label: css`
    color: var(--cds-color-interactive-primary);
  `,
};

const ToggleButtonForTogglableContent = ({ collapsed }: ToggleButtonForTogglableContentProps) => {
  return (
    <React.Fragment>
      <Typography2 variant="actionSecondary" component="span" css={styles.label}>
        {collapsed ? _t('Show more') : _t('Show less')}
      </Typography2>
    </React.Fragment>
  );
};

export default ToggleButtonForTogglableContent;
